import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class StaticJsonCacheBusterInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const isStaticJsonAsset =
      request.method === 'GET' &&
      /(?:^|\/)assets\/.*\.json(?:$|[?#])/.test(request.url);

    if (!isStaticJsonAsset || /[?&]v=/.test(request.urlWithParams)) {
      return next.handle(request);
    }

    return next.handle(
      request.clone({ setParams: { v: environment.buildVersion } })
    );
  }
}
